import React from 'react';
import {
  Button,
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import AccountInfoSummary from 'views/sast2/components/AccountInfoSummary';
import { getHostLabel } from 'views/sast2/helper';

const ReConnectAccountModal = ({ hostType, account, onConnect, onClose }) => {
  const toggleModal = () => {
    onClose();
  };

  return (
    <Card>
      <Modal isOpen={true} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Re-Connect Your {getHostLabel(hostType)} Account
        </ModalHeader>
        <ModalBody>
          <div>
            <AccountInfoSummary
              props={account}
              description={'Account is disconnected.'}
              mode={'normal'}
            />
          </div>
          <p>
            Please review the account information above. If you have access to
            the respective {getHostLabel(account.host_type)} account then
            proceed to re-authorize and re-connect this account.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => onConnect()}>
            Re-Connect Account
          </Button>{' '}
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

export default ReConnectAccountModal;
